export const scrollTo = (refPoint: React.MutableRefObject<HTMLDivElement>) => {
  refPoint.current.scrollIntoView({
    block: 'start',
    behavior: 'smooth',
  });
};